// extracted by mini-css-extract-plugin
export var base = "_30-0";
export var updateBanner = "_30-1";